// Glob import components' and libraries' JS.
import "./Program.cs.js";
import "./Services/AppThemeService.cs.js";
import "./App.razor.js";
import "./bin/Release/net7.0/publish/wwwroot/App.razor.js";
import "./obj/Release/net7.0/PubTmp/Out/wwwroot/App.razor.js";

// Import Bootstrap's JS.
import "bootstrap";